import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";

export default function ExWeapon({ data }) {
  return (
    <Card variant="outlined" style={{ height: "100%", borderRadius: 20 }}>
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
      >
        <img
          style={{ width: 150, height: 150, borderRadius: "50%" }}
          alt="equipIcons"
          src={data.icon}
        />
      </Stack>
      <CardHeader title={data.characterFor} style={{ textAlign: "center" }} />
      <CardContent>
        <Typography style={{ textAlign: "center" }}>{data.effect}</Typography>
      </CardContent>
    </Card>
  );
}
